import React from "react";
import { useForm } from "@formspree/react";
import { Button, Row, Col, Form, FormGroup, Label, Input } from "reactstrap";

import { motion } from "framer-motion";

const Contact = () => {
  const mapcss = `
  .mapouter {
    position:relative;
    text-align:right;
    height:400px;
    width:400px;
  }
  `;
  const gmapcss = `
  .gmap_canvas { 
    overflow:hidden;
    background:none!important;
    height:400px;
    width:400px;
  }
  `;

  const [state, handleSubmit] = useForm("mrgjypqe");
  if (state.succeeded) {
    return (
      <motion.div
        className="container p-5"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Row className="text-center pb-5">
          <Col>
            <h4 className="display-6"> Thank you for reaching out! </h4>
            <hr />
            <p>
              I will reach about you next project as soon as possible! Click{" "}
              <a href="/contact">here</a> to return to send another message
            </p>
          </Col>
        </Row>
      </motion.div>
    );
  }

  return (
    <motion.div
      className="container"
      id="contactpage"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Row>
        <Col>
          <h2>Contact Me</h2>
          <hr />
        </Col>
      </Row>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col className="p-5" xs={{ span: 12, order: 2 }} md={6}>
            <h4>Contact Info</h4>
            <hr />
            <h6>Address</h6>
            <div className="mapouter">
              <div className="gmap_canvas">
                <iframe
                  width="400"
                  height="400"
                  id="gmap_canvas"
                  src="https://maps.google.com/maps?q=Egg+Harbor+Township,%20NJ%2008234&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                  title="Google Map"
                ></iframe>
                <br />
                <style>{mapcss}</style>
                <style>{gmapcss}</style>
              </div>
            </div>
            <br />
            <h6>Email</h6>
            <a href="mailto:jpwpressurewashing@gmail.com">
              jpwpressurewashing@gmail.com
            </a>
            <br />
            <h6>Contact Number</h6>
            <a href="tel:+16094575114">+1 (609) 457-5114</a>
          </Col>
          <Col className="p-5" xs={{ span: 12, order: 1 }} md={6}>
            <h4>Send Me A Message</h4>
            <hr />
            <FormGroup>
              <Label for="contactName">Name</Label>
              <Input
                className="form-control mb-2"
                type="text"
                name="contactName"
                id="contactName"
                placeholder="Please enter your name."
                required
              />
              <Label htmlFor="email" for="contactEmail">
                Email
              </Label>
              <Input
                className="form-control mb-2"
                type="email"
                name="contactEmail"
                id="contactEmail"
                placeholder="Please enter your email."
                required
              />
              <Label for="contactPhone">Phone Number</Label>
              <Input
                className="form-control mb-2"
                type="phone"
                name="contactPhone"
                id="contactPhone"
                placeholder="Please enter your phone number."
                required
              />
              <Label for="contactMessage">Message</Label>
              <Input
                className="form-control mb-2"
                type="textarea"
                name="contactMessage"
                id="contactMessage"
                placeholder="Please write a brief description of your project. Details are appreciated if possible..."
                rows={5}
                required
              />
            </FormGroup>
            <Button type="submit" disabled={state.submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </motion.div>
  );
};

export default Contact;
